<template>
    <keep-alive>
        <component
            class="progress-bar"
            v-bind:is="currentStageComponent"
            :stage-headers="stageHeaders"
        ></component>
    </keep-alive>
</template>

<script>
const Register = () =>
    import(/* webpackChunkName: "enrolment-bundle" */ '@C/SVG/step1.vue');
const Personal = () =>
    import(/* webpackChunkName: "enrolment-bundle" */ '@C/SVG/step1.vue');
const HomeAddress = () =>
    import(/* webpackChunkName: "enrolment-bundle" */ '@C/SVG/step2.vue');
const Subscription = () =>
    import(/* webpackChunkName: "enrolment-bundle" */ '@C/SVG/step4.vue');
const BillingAddress = () =>
    import(/* webpackChunkName: "enrolment-bundle" */ '@C/SVG/step3.vue');
const Confirmation = () =>
    import(/* webpackChunkName: "enrolment-bundle" */ '@C/SVG/step5.vue');
const Payment = () =>
    import(/* webpackChunkName: "enrolment-bundle" */ '@C/SVG/step6.vue');
export default {
    name: 'EnrolmentProgress',
    data() {
        return {
            Register,
            Personal,
            HomeAddress,
            Subscription,
            BillingAddress,
            Confirmation,
            Payment
        };
    },
    props: {
        currentStage: {
            type: String,
            required: true
        }
    },
    computed: {
        currentStageComponent() {
            return this[this.currentStage];
        },
        stageHeaders() {
            return {
                personalInfo: this.$gettext('Personal Info'),
                subscription: this.$gettext('Subscription'),
                billingInfo: this.$gettext('Billing info'),
                confirmation: this.$gettext('Confirmation'),
                payment: this.$gettext('Payment')
            }
        }
    },
    components: {
        Register,
        Personal,
        HomeAddress,
        Subscription,
        BillingAddress,
        Confirmation,
        Payment
    }
};
</script>




// WEBPACK FOOTER //
// resources/assets/js/components/EnrolmentProgress.vue